<template>
  <div class="ti-wrap">
    <span v-if="icon" class="ti-icon" aria-hidden="true">
      <!-- USER -->
      <svg v-if="icon === 'user'" viewBox="0 0 24 24" fill="none">
        <path
          d="M20 21c0-3.314-3.582-6-8-6s-8 2.686-8 6"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <!-- LOCK -->
      <svg v-else-if="icon === 'lock'" viewBox="0 0 24 24" fill="none">
        <path
          d="M7 11V8a5 5 0 0 1 10 0v3"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M6 11h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linejoin="round"
        />
      </svg>
    </span>

    <input
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :min="min"
      :max="max"
      :value="modelValue"
      :autocomplete="name + '-new'"
      @input="$emit('update:modelValue', $event.target.value)"
      class="form-control neu-pill"
      :class="{ 'has-icon': !!icon }"
      v-bind="$attrs"
    />

    <div v-if="help" class="form-text neu-help">{{ help }}</div>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  inheritAttrs: false,
  props: {
    name: String,
    type: String,
    placeholder: String,
    required: {
      type: Boolean,
      default: false,
    },
    min: String,
    max: String,
    modelValue: [String, Number],
    help: String,

    // "user" | "lock"
    icon: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.ti-wrap {
  width: 100%;
  position: relative;
}

/* Ícono dentro del input */
.ti-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: #7b8aa0;
  pointer-events: none;
}

.ti-icon svg {
  width: 18px;
  height: 18px;
}

/* Input estilo capsulita (sombra suave + luz como la imagen) */
.neu-pill {
  width: 100%;
  height: 46px;
  border: 0 !important;
  outline: none !important;

  border-radius: 999px !important;
  background: #e9eef5 !important;

  font-family: "Nunito", sans-serif !important;
  font-size: 0.95rem;
  color: #7B8AA0 !important;

  padding: 0 18px;

  /* 🔥 más suave (menos sombra) + “luz” más sutil */
  box-shadow:
    inset 5px 5px 10px rgba(153, 171, 196, 0.40),
    inset -5px -5px 10px rgba(255, 255, 255, 0.95),
    0 1px 0 rgba(255, 255, 255, 0.65);

  transition: box-shadow 0.2s ease;
}

.neu-pill.has-icon {
  padding-left: 46px;
}

.neu-pill::placeholder {
  color: #94a3b8;
}

/* Focus: un poquito más marcado, pero todavía suave */
.neu-pill:focus {
  box-shadow:
    inset 6px 6px 12px rgba(153, 171, 196, 0.42),
    inset -6px -6px 12px rgba(255, 255, 255, 0.98),
    0 1px 0 rgba(255, 255, 255, 0.7);
}
.neu-pill:active {
    color: #7B8AA0 !important;
}
.neu-pill:focus {
    color: #7B8AA0 !important;
}

.neu-help {
  margin-top: 6px;
  color: #7b8aa0;
  font-size: 0.85rem;
}
</style>
